import { Injectable } from "@angular/core";

@Injectable({
  providedIn: 'root'
})

export abstract class TokenService {
  abstract getToken(): Promise<string>;

}
